<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div class="card_container" style="flex: 0 0 20%">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="mt-3 col-md-12 fuel_consumption_btn_div">
              <div
                class="fuel_consumption_button"
                :class="[activeTab === 'chart' ? 'active_tab' : null]"
                style="height: 80px; width: 80px"
              >
                <h3 class="text-white primary_text">
                  {{ salesTransationsCount }}
                </h3>
              </div>
              <div class="mt-2 text-center voucher_type primary_text">
                {{ $t("text.bVarianceReport.totalTransactions") }}
              </div>
            </div>
          </div>
        </div>
        <div class="card_container" style="flex: 0 0 20%">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="mt-3 col-md-12 fuel_consumption_btn_div">
              <div
                class="fuel_consumption_button installed__tanks_dropdown__row showAllContainer"
                width="100%"
                style="
                  width: 100%;
                  padding: 5px;
                  background: rgb(75, 44, 114);
                  cursor: pointer;
                "
              >
                <div
                  class="row installed__pumps_dropdown align-items-center"
                  @click="toggleTransactionsDropDown"
                  v-on:mouseleave="
                    showTransactionOptions === true
                      ? (showTransactionOptions = false)
                      : ''
                  "
                >
                  <div class="col-md-3 dropdown_img">
                    <img src="@/assets/img/y.png" />
                  </div>
                  <div class="col-md-7">
                    <input
                      type="text"
                      class="installed__pumps_dropdown_input"
                      readonly
                      v-model="transFilter"
                    />
                  </div>
                  <div class="col-md-2">
                    <div>
                      <i
                        style="float: right; font-size: 25px; color: white"
                        class="fa fa-angle-right"
                        :class="[
                          showTransactionOptions ? 'downArrow' : 'upArrow',
                        ]"
                      ></i>
                    </div>
                  </div>

                  <div
                    class="return_balance_to_drop_dwon"
                    ref="balance_to_drop_down_menu"
                    v-if="showTransactionOptions"
                  >
                    <hr class="mt-2" />
                    <div
                      class="mt-2 row active_validity_drop_down_list align-items-center"
                      ref="balance_to_list_row"
                      @click="selectItem($t('text.bVarianceReport.showAll'))"
                    >
                      <div class="col-md-8">
                        <h3
                          class="mt-2 dropdown_header_text validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ $t("text.bVarianceReport.showAll") }}
                        </h3>
                      </div>
                      <div class="text-right col-md-4"></div>
                    </div>
                    <div
                      class="mt-2 row active_validity_drop_down_list align-items-center"
                      ref="balance_to_list_row"
                      v-for="(prod, index) in products"
                      :key="index"
                      @click="selectItem(prod)"
                    >
                      <div class="col-md-8">
                        <h3
                          class="mt-2 dropdown_header_text validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ prod }}
                        </h3>
                      </div>
                      <div class="text-right col-md-4"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-2 text-center voucher_type primary_text">
                {{ $t("text.bVarianceReport.productFilter") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuel_consumption_row_right_section_nw vr__bg"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row align-items-center" style="height: 100%">
            <div class="col-md-5">
              <div
                class="text-center transaction_period_text branch__sales__text"
                style="font-size: 22px"
              >
                {{ $t("text.bVarianceReport.title") }}
              </div>
            </div>
            <div
              class="col-md-5 drop_down_input_group sales_transaction_dropdown"
            >
              <div class="mt-2 mr-2 drop_down_section">
                <div class="drop_down_div align-items-center">
                  <vue-ctk-date-time-picker
                    v-model="dateRange"
                    :max-date="maxDate"
                    :range="true"
                    :autoClose="true"
                    :locale="this.$root.$i18n.locale"
                    :custom-shortcuts="customShortcuts"
                    :color="$store.getters.getDatePickerColor"
                    format="DDMMYYYY"
                    formatted="DD/MM/YYYY"
                    :label="$t('text.calendar.dateRange')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="mt-3 row dashboard_first_row">
        <section class="col-md-4 card_row" :class="productCount" v-if="hasPms">
          <div class="mt-3 variance_card dashboard_card_1">
            <div class="variance_product_container variance_pms">
              <div class="variance_product">
                <h4 style="margin-bottom: 0">
                  {{ countryProducts.products.product1 }}
                </h4>
                <img src="@/assets/img/drop-of-liquid.png" width="20px" />
              </div>
            </div>
            <div class="variance_information">
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.eVolumeSold") }}
                </p>
                <p class="variance_manual">
                  {{ convertThousand(totalPmsVol) }}
                </p>
              </div>
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.mVolumeSold") }}
                </p>
                <p class="variance_manual">
                  {{ convertThousand(totalManualPmsVol) }}
                </p>
              </div>
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.variance") }}
                </p>
                <p class="variance_manual">
                  {{ convertThousand(totalPmsVol - totalManualPmsVol) }}
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="col-md-4 card_row" :class="productCount" v-if="hasAgo">
          <div class="mt-3 variance_card dashboard_card_1">
            <div class="variance_product_container variance_ago">
              <div class="variance_product">
                <h4 style="margin-bottom: 0">
                  {{ countryProducts.products.product2 }}
                </h4>
                <img src="@/assets/img/drop-of-liquid.png" width="20px" />
              </div>
            </div>
            <div class="variance_information">
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.eVolumeSold") }}
                </p>
                <p class="variance_manual">
                  {{ convertThousand(totalAgoVol) }}
                </p>
              </div>
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.mVolumeSold") }}
                </p>
                <p class="variance_manual">
                  {{ convertThousand(totalManualAgoVol) }}
                </p>
              </div>
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.variance") }}
                </p>
                <p class="variance_manual">
                  {{ convertThousand(totalAgoVol - totalManualAgoVol) }}
                  <!-- {{agoCheck == 0 || agoCheck == null ? 'N/A' : totalAgoVariance}} -->
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="col-md-4 card_row" :class="productCount" v-if="hasDpk">
          <div class="mt-3 variance_card dashboard_card_1">
            <div class="variance_product_container variance_dpk">
              <div class="variance_product">
                <h4 style="margin-bottom: 0">
                  {{ countryProducts.products.product3 }}
                </h4>
                <img src="@/assets/img/drop-of-liquid.png" width="20px" />
              </div>
            </div>
            <div class="variance_information">
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.eVolumeSold") }}
                </p>
                <p class="variance_manual">
                  {{ convertThousand(totalDpkVol) }}
                </p>
              </div>
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.mVolumeSold") }}
                </p>
                <p class="variance_manual">
                  {{ convertThousand(totalManualDpkVol) }}
                </p>
              </div>
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.variance") }}
                </p>
                <p class="variance_manual">
                  <!-- {{dpkCheck == 0 || dpkCheck == null ? 'N/A' : totalDpkVariance}} -->
                  {{ convertThousand(totalDpkVol - totalManualDpkVol) }}
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="col-md-4 card_row" :class="productCount" v-if="hasLpg">
          <div class="mt-3 variance_card dashboard_card_1">
            <div class="variance_product_container variance_lpg">
              <div class="variance_product">
                <h4 style="margin-bottom: 0">
                  {{ countryProducts.products.product4 }}
                </h4>
                <img src="@/assets/img/drop-of-liquid.png" width="20px" />
              </div>
            </div>
            <div class="variance_information">
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.eVolumeSold") }}
                </p>
                <p class="variance_manual">
                  {{ convertThousand(totalLpgVol) }}
                </p>
              </div>
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.mVolumeSold") }}
                </p>
                <p class="variance_manual">
                  {{ convertThousand(totalManualLpgVol) }}
                </p>
              </div>
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.variance") }}
                </p>
                <p class="variance_manual">
                  <!-- {{lpgCheck == 0 || lpgCheck == null ? 'N/A' : totalLpgVariance}} -->
                  {{ convertThousand(totalLpgVol - totalManualLpgVol) }}
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="col-md-4 card_row" :class="productCount">
          <div class="mt-3 variance_card dashboard_card_1">
            <div class="variance_product_container variance_total">
              <div class="variance_product">
                <h4 style="margin-bottom: 0">
                  {{ $t("text.bVarianceReport.total") }}
                </h4>
                <img src="@/assets/img/drop-of-liquid.png" width="20px" />
              </div>
            </div>
            <div class="variance_information">
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.eVolumeSold") }}
                </p>
                <p class="variance_manual">{{ convertThousand(totalVol) }}</p>
              </div>
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.mVolumeSold") }}
                </p>
                <p class="variance_manual">
                  {{ convertThousand(totalManualVol) }}
                </p>
              </div>
              <div class="variance_report_holder">
                <p class="variance_report">
                  {{ $t("text.bVarianceReport.variance") }}
                </p>
                <p class="variance_manual">
                  <!-- {{totalCheck == 0 ? 'N/A' : totalVariance}} -->
                  {{ convertThousand(totalVol - totalManualVol) }}
                </p>
              </div>
            </div>
          </div>
        </section>
      </section>

      <!-- <section class="mt-3 full__row_section" v-if="tankList.length > 0">
        <h4 class="text-center py-3">Pump Tank Sales</h4>
        <div class="row">
          <div
            class="col-md-12 col-lg-6 col-sm-12"
            v-for="(sale, i) in tankList"
            :key="i + 'A'"
          >
            <div class="table-container">
              <div class="table">
                <div class="row inner-table-container">
                  //1st column
                  <div class="col-2 border border-left-0 border-top-0 pt-2">
                    <p>Tanks</p>
                  </div>
                  //SECOND N THIRD COLUMN
                  <div class="col-6">
                    <div
                      class="row"
                      v-for="(tank, i) in sale.tankSales"
                      :key="i + 'A'"
                    >
                      //SECOMD
                      <div class="col-7 border pt-2 border-left-0" style="">
                        <p>{{ tank.name }}</p>
                      </div>
                      //THIRD
                      <div
                        class="col-5 border pt-2 border-left-0 border-right-0"
                      >
                        <p>
                          {{
                            tank.volume.toLocaleString("en", {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  //TANK TOTAL
                  <div class="col-4 border border-right-0 border-top-0 pt-2">
                    <p>
                      <span style="font-weight: bold">TOTAL: </span>
                      {{ sale.totalTankSale }}
                    </p>
                  </div>
                </div>

                //PUMPS
                <div class="row inner-table-container">
                  <div class="col-2 border border-left-0 border-top-0 pt-2">
                    <p>{{ $t("text.bMasterLayout.pumps") }}</p>
                  </div>

                  <div class="col-6">
                    <div
                      class="row"
                      v-for="(pump, i) in sale.pumpSales"
                      :key="i + 'A'"
                    >
                      <div class="col-7 border pt-2 border-left-0">
                        <p>{{ pump.name }}</p>
                      </div>

                      <div
                        class="col-5 border pt-2 border-left-0 border-right-0"
                      >
                        <p>
                          {{
                            pump.volume.toLocaleString("en", {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })
                          }}
                        </p>
                      </div>
                    </div>
                  </div>

                  //TOTAL
                  <div class="col-4 border border-right-0 border-top-0 pt-2">
                    <p>
                      <span style="font-weight: bold"
                        >{{ $t("text.productSummary.total") }}:
                      </span>
                      {{ sale.totalPumpSale }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> -->

      <div class="mt-3">
        <section class="section__row">
          <div class="mt-3">
            <div class="branch__sales__text_header">
              <div class="row top_section_row" v-show="!showLoader">
                <div class="col-md-8">
                  <span class="sec_text_color">
                    <img src="@/assets/img/hand (1).png" class="mr-3" />
                    {{ $t("text.bVarianceReport.reportBetween") }}
                    {{
                      $d(new Date(startDate), "short", this.$root.$i18n.locale)
                    }}
                    {{ $t("text.and.text") }}
                    {{
                      $d(new Date(endDate), "short", this.$root.$i18n.locale)
                    }}
                  </span>
                  <span> </span>
                </div>
                <div class="text-right col-md-4">
                  <!-- <button class="show_more_button remove_text_decoration"  @click="downloadWithCSS">
                  Download Sales Report
                </button> -->
                </div>
              </div>
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :dataBound="dataBound"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :excelQueryCellInfo="excelQueryCellInfo"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column width="40" field="index" headerText="#"></e-column>
                  <e-column
                    field="dateModified"
                    width="160"
                    :headerText="$t('text.bVarianceReport.date')"
                    :format="formatOptions"
                    type="date"
                  ></e-column>
                  <e-column
                    field="pumpName"
                    width="150"
                    :headerText="$t('text.bVarianceReport.pumpName')"
                  ></e-column>
                  <e-column
                    field="productName"
                    width="120"
                    :headerText="$t('text.bVarianceReport.product')"
                  ></e-column>
                  <e-column
                    width="210"
                    field="volumeSold"
                    format="N2"
                    :headerText="$t('text.bVarianceReport.eVolumeSoldLtr')"
                  ></e-column>
                  <e-column
                    width="210"
                    field="manualVolumeSold"
                    format="N2"
                    :headerText="$t('text.bVarianceReport.mVolumeSoldLtr')"
                  ></e-column>
                  <e-column
                    width="130"
                    field="pumpVariance"
                    format="N2"
                    :headerText="$t('text.bVarianceReport.varianceLtr')"
                  ></e-column>
                  <e-column
                    field="openingReading"
                    format="N2"
                    width="240"
                    :headerText="$t('text.bVarianceReport.eOpeningReading')"
                  ></e-column>
                  <e-column
                    field="lastReading"
                    format="N2"
                    width="210"
                    :headerText="$t('text.bVarianceReport.eLastReading')"
                  ></e-column>
                  <e-column
                    field="manualOpeningReading"
                    format="N2"
                    width="240"
                    :headerText="$t('text.bVarianceReport.mOpeningReading')"
                  ></e-column>

                  <e-column
                    field="manualLastReading"
                    format="N2"
                    width="210"
                    :headerText="$t('text.bVarianceReport.mLastReading')"
                  ></e-column>
                  <!-- <e-column field="amountSold" width="180" headerText="Amount"></e-column> -->
                  <e-column
                    width="450"
                    :template="buttonsTemplate"
                    :headerText="$t('text.actionButtons.title')"
                  ></e-column>
                </e-columns>
              </ejs-grid>
              <TableLoader :showLoader="showLoader" />
            </div>
          </div>
        </section>
        <div id="rentalListCan"></div>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/danskebank.jpg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import Temp from "@/components/TableTemplates/branchVarianceReport.vue";
import countryProducts from "@/products";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "VarianceReport",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      tankList: [],
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      hasLpg: false,
      hasPms: false,
      hasAgo: false,
      hasDpk: false,
      productCount: "col-lg-3",
      transKeep: [],
      totalPmsAmount: 0,
      totalPmsVol: 0,
      totalManualPmsAmount: 0,
      totalManualPmsVol: 0,
      totalAgoAmount: 0,
      totalAgoVol: 0,
      totalManualAgoAmount: 0,
      totalManualAgoVol: 0,
      totalDpkAmount: 0,
      totalDpkVol: 0,
      totalManualDpkAmount: 0,
      totalManualDpkVol: 0,
      totalLpgAmount: 0,
      totalLpgVol: 0,
      totalManualLpgAmount: 0,
      totalManualLpgVol: 0,
      totalAmount: 0,
      totalManualAmount: 0,
      totalPmsVariance: 0,
      totalAgoVariance: 0,
      totalDpkVariance: 0,
      totalLpgVariance: 0,
      totalVol: 0,
      totalManualVol: 0,
      totalPmsVariance: 0,
      totalAgoVariance: 0,
      totalDpkVariance: 0,
      totalLpgVariance: 0,
      totalVariance: 0,
      branchIcon: "",
      company: "",
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      transFilter: this.$t("text.bVarianceReport.showAll"),
      startDate: this.$moment().subtract(1, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().subtract(1, "days").format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(1, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().subtract(1, "days").format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      backgroundUrl,
      branch: {},
      branchId: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      branches: 0,
      dealers: 0,
      salesTransactions: [],
      showLoader: false,
      showAll: false,
      lowTanks: [],
      products: [],
      pmsCheck: 0,
      agoCheck: 0,
      dpkCheck: 0,
      lpgCheck: 0,
      totalCheck: 0,
      pmsRate: 0,
      agoRate: 0,
      dpkRate: 0,
      lpgRate: 0,
      todaysDate: new Date(),
      activeTab: "chart",
      productSummary: [],
      showTransactionOptions: false,
      pmsSummary: { volume: 0, amount: 0 },
      agoSummary: { volume: 0, amount: 0 },
      dpkSummary: { volume: 0, amount: 0 },
      lpgSummary: { volume: 0, amount: 0 },
      salesTransationsCount: 0,
      buttonsTemplate: function () {
        return {
          template: Temp,
        };
      },
    };
  },
  created() {
    document.title = "Variance Report:: Epump Retail Outlet";
    if (localStorage.getItem("companyDetails")) {
      this.company = JSON.parse(localStorage.getItem("companyDetails"));
      this.branchIcon = "https://app.epump.com.ng" + this.company.url;
    } else {
      this.branchIcon = "@/assets/img/avatar.svg";
    }

    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.dateRange.start = this.$moment(this.$route.query.startDate).format(
        "D-M-YYYY"
      );
      this.dateRange.end = this.$moment(this.$route.query.endDate).format(
        "D-M-YYYY"
      );
    } else {
      this.dateRange.start = this.pluginStartDate;
      this.dateRange.end = this.pluginEndDate;

      this.$router.replace({
        name: this.$route.name,
        query: {
          branchId: this.$route.query.branchId
            ? this.$route.query.branchId
            : this.branch.id,
          regionId: this.$route.query.regionId,
          dealerId: this.$route.query.dealerId,
          groupId: this.$route.query.groupId,
          companyId: this.$route.query.companyId,
          startDate: this.$moment(this.pluginStartDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
          endDate: this.$moment(this.pluginEndDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
        },
      });
    }

    // this.dateRange.start = this.pluginStartDate;
    // this.dateRange.end = this.pluginEndDate;

    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }

    this.showLoader = true;
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Variance Report:: ${branch.name} Retail Outlet`;
      this.branch.companyNameAbbr = branch.companyName.charAt(0).toUpperCase();
    });

    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDay();
    this.todaysDate = day + "-" + month + "-" + year;
    this.todaysDate = this.$moment(date, "DD-MM-YYYY").format("MMMM D, YYYY");
  },

  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        if (this.$route.query.branchId) {
          this.branchId = this.branch.id;
          if (this.branchId !== null) {
            this.getProductSummary();
            this.getVarianceReport();
            this.getTankPumpSale();
          }
        } else {
          if (this.branch.id) {
            this.branchId = this.branch.id;
          }
          if (this.branchId !== null) {
            this.getProductSummary();
            this.getVarianceReport();
            this.getTankPumpSale();
          }
        }
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.$router.replace({
          name: this.$route.name,
          query: {
            branchId: this.$route.query.branchId
              ? this.$route.query.branchId
              : this.branch.id,
            regionId: this.$route.query.regionId,
            dealerId: this.$route.query.dealerId,
            groupId: this.$route.query.groupId,
            companyId: this.$route.query.companyId,
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });

        this.getProductSummary();
        this.getVarianceReport();
        this.getTankPumpSale();
      }
    },
  },
  beforeDestroy() {},
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },

  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "dateModified") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    downloadWithCSS() {
      var elementHTML = $("#pdfContent").html();
      var myWindow = window.open("", "", "width=1000,height=700");
      myWindow.document.write(elementHTML);
      var style = myWindow.document.createElement("style");
      style.innerHTML = `
    @page {
      size: auto;  /* auto is the initial value */
      margin: 0mm; /* this affects the margin in the printer settings */
    }
    html {
      background-color: #FFFFFF;
      margin: 0px; /* this affects the margin on the HTML before sending to printer */
    }
    body {
      margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
      margin: 0mm;
    }
    .data__row:nth-child(even) {
      background: #dbdbdb;
      -webkit-print-color-adjust: exact;  print-color-adjust: exact;
    }

    .data__row:nth-child(odd) {
       background: white;
      -webkit-print-color-adjust: exact;  print-color-adjust: exact;
    }
    table {
       border-collapse: collapse;
    }
    `;
      myWindow.document.head.appendChild(style);
      myWindow.document.close();
      myWindow.focus();
      myWindow.print();
      myWindow.close();
    },
    toggleTransactionsDropDown() {
      this.showTransactionOptions = !this.showTransactionOptions;
    },

    selectItem(item) {
      this.transFilter = item;
      this.showTransactionOptions = false;
      this.showTransactionOptions = !this.showTransactionOptions;
      let newTrans = [];
      if (item !== this.$t("text.bVarianceReport.showAll")) {
        let index = 0;
        newTrans = this.transKeep.filter((trans) => trans.productName == item);
        newTrans.forEach((cur) => {
          index++;
          cur.index = index;
        });
      } else {
        let index = 0;
        newTrans = this.transKeep;
        newTrans.forEach((cur) => {
          index++;
          cur.index = index;
        });
      }
      this.$refs.dataGrid.ej2Instances.setProperties({
        dataSource: newTrans,
      });
      this.salesTransationsCount = newTrans.length;
      this.refreshGrid();
    },

    activateTab(voucher_type) {
      this.activeTab = voucher_type;
    },
    dataBound: function () {
      this.$refs.dataGrid.autoFitColumns();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    rowDataBound: function (arging) {
      arging.row.children[5].addEventListener("mouseover", (e) => {
        arging.row.children[5].innerHTML =
          '<button type="button" class="variance-btn" id="rejectData">Reject</button>';
      });
      arging.row.children[5].addEventListener("mouseleave", (e) => {
        arging.row.children[5].innerHTML = "0.00";
      });

      arging.row.children[9].addEventListener("mouseover", (e) => {
        arging.row.children[9].innerHTML =
          '<button class="variance-btn" id="rejectData">Reject</button>';
      });
      arging.row.children[9].addEventListener("mouseleave", (e) => {
        arging.row.children[9].innerHTML = "0.00";
      });

      arging.row.children[10].addEventListener("mouseover", (e) => {
        arging.row.children[10].innerHTML =
          '<button type="button" class="variance-btn" id="rejectData">Reject</button>';
      });
      arging.row.children[10].addEventListener("mouseleave", (e) => {
        arging.row.children[10].innerHTML = "0.00";
      });
    },

    displayProductSummary(productSummary) {
      let prodCount = 0;
      let psummary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product1
      );
      if (psummary.length) {
        this.pmsSummary = psummary[0];
        this.hasPms = true;
        prodCount++;
      }

      let asummary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product2
      );
      if (asummary.length) {
        this.agoSummary = asummary[0];
        this.hasAgo = true;
        prodCount++;
      }

      let dsummary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product3
      );
      if (dsummary.length) {
        this.dpkSummary = dsummary[0];
        this.hasDpk = true;
        prodCount++;
      }

      let lsummary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product4
      );
      if (lsummary.length) {
        this.lpgSummary = lsummary[0];
        this.hasLpg = true;
        prodCount++;
      }
      prodCount++;
      let columnNumber;
      prodCount !== 5 ? (columnNumber = 12 / prodCount) : (columnNumber = 3);
      this.productCount = `col-lg-${columnNumber}`;
    },
    getProductSummary() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/DaySale/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.productSummary = response.data;
          this.displayProductSummary(response.data);
        })
        .catch((error) => {});
    },
    getTankPumpSale() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/audit/pumpTankSales/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.forEach((data) => {
            let tankSaleTotal = data.tankSales.reduce((prev, cur) => {
              return prev + cur.volume;
            }, 0);

            let pumpSaleTotal = data.pumpSales.reduce((prev, cur) => {
              return prev + cur.volume;
            }, 0);
            data.totalTankSale = tankSaleTotal.toLocaleString("en", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            });
            data.totalPumpSale = pumpSaleTotal.toLocaleString("en", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            });
          });

          this.tankList = res.data;
        });
    },

    getVarianceReport() {
      this.showLoader = true;
      this.transFilter = this.$t("text.bVarianceReport.showAll");
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pumps/BranchVariance/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          let index = 0;
          let totalPmsVol = 0;
          let totalPmsAmount = 0;
          let totalManualPmsAmount = 0;
          let totalManualPmsVol = 0;
          let totalAgoAmount = 0;
          let totalAgoVol = 0;
          let totalManualAgoAmount = 0;
          let totalManualAgoVol = 0;
          let totalDpkAmount = 0;
          let totalDpkVol = 0;
          let totalManualDpkAmount = 0;
          let totalManualDpkVol = 0;
          let totalLpgAmount = 0;
          let totalLpgVol = 0;
          let totalManualLpgAmount = 0;
          let totalManualLpgVol = 0;

          let totalPmsVariance = 0;
          let totalAgoVariance = 0;
          let totalDpkVariance = 0;
          let totalLpgVariance = 0;

          response.data.forEach((sale) => {
            if (sale.productName === this.countryProducts.products.product1) {
              totalPmsAmount += sale.amountSold;
              totalPmsVol += sale.volumeSold;
              totalManualPmsAmount += sale.mannualAmountSold;
              totalManualPmsVol =
                sale.mannualVolumeSold != null
                  ? totalManualPmsVol + sale.mannualVolumeSold
                  : null;
              totalPmsVariance =
                sale.pumpVariance != null
                  ? totalPmsVariance + sale.pumpVariance
                  : null;
            }
            if (sale.productName === this.countryProducts.products.product2) {
              totalAgoAmount += sale.amountSold;
              totalAgoVol += sale.volumeSold;
              totalManualAgoAmount += sale.mannualAmountSold;
              totalManualAgoVol =
                sale.mannualVolumeSold != null
                  ? totalManualAgoVol + sale.mannualVolumeSold
                  : null;
              totalAgoVariance =
                sale.pumpVariance != null
                  ? totalAgoVariance + sale.pumpVariance
                  : null;
            }
            if (sale.productName === this.countryProducts.products.product3) {
              totalDpkAmount += sale.amountSold;
              totalDpkVol += sale.volumeSold;
              totalManualDpkAmount += sale.mannualAmountSold;
              totalManualDpkVol =
                sale.mannualVolumeSold != null
                  ? totalManualDpkVol + sale.mannualVolumeSold
                  : null;
              totalDpkVariance =
                sale.pumpVariance != null
                  ? totalDpkVariance + sale.pumpVariance
                  : null;
            }
            if (sale.productName === this.countryProducts.products.product4) {
              totalLpgAmount += sale.amountSold;
              totalLpgVol += sale.volumeSold;
              totalManualLpgAmount += sale.mannualAmountSold;
              totalManualLpgVol =
                sale.mannualVolumeSold != null
                  ? totalManualLpgVol + sale.mannualVolumeSold
                  : null;
              totalLpgVariance =
                sale.pumpVariance != null
                  ? totalLpgVariance + sale.pumpVariance
                  : null;
            }
          });

          response.data
            .sort((a, b) => {
              if (a.dateOpened !== b.dateOpened) {
                return a.dateOpened > b.dateOpened
                  ? -1
                  : a.dateOpened < b.dateOpened
                  ? 1
                  : 0;
              }
            })
            .sort((a, b) => {
              if (a.dateOpened.split("T")[0] == b.dateOpened.split("T")[0]) {
                return a.pumpName.toLowerCase() < b.pumpName.toLowerCase()
                  ? -1
                  : a.pumpName.toLowerCase() > b.pumpName.toLowerCase()
                  ? 1
                  : 0;
              }
            });

          this.totalPmsAmount = this.convertThousand(totalPmsAmount);
          this.totalPmsVol = totalPmsVol;
          this.totalManualPmsAmount =
            this.convertThousand(totalManualPmsAmount);
          this.totalManualPmsVol =
            totalManualPmsVol != null ? totalManualPmsVol : 0;

          this.totalAgoAmount = this.convertThousand(totalAgoAmount);
          this.totalAgoVol = totalAgoVol;
          this.totalManualAgoAmount =
            this.convertThousand(totalManualAgoAmount);
          this.totalManualAgoVol =
            totalManualAgoVol != null ? totalManualAgoVol : 0;

          this.totalDpkAmount = this.convertThousand(totalDpkAmount);
          this.totalDpkVol = totalDpkVol;
          this.totalManualDpkAmount =
            this.convertThousand(totalManualDpkAmount);
          this.totalManualDpkVol =
            totalManualDpkVol != null ? totalManualDpkVol : 0;

          this.totalLpgAmount = this.convertThousand(totalLpgAmount);
          this.totalLpgVol = totalLpgVol;
          this.totalManualLpgAmount =
            this.convertThousand(totalManualLpgAmount);
          this.totalManualLpgVol =
            totalManualLpgVol != null
              ? this.convertThousand(totalManualLpgVol)
              : 0;

          this.totalPmsVariance =
            totalPmsVariance != null ? totalPmsVariance : 0;
          this.totalAgoVariance =
            totalAgoVariance != null ? totalAgoVariance : 0;
          this.totalDpkVariance =
            totalDpkVariance != null ? totalDpkVariance : 0;
          this.totalLpgVariance =
            totalLpgVariance != null ? totalLpgVariance : 0;
          this.totalVariance =
            totalPmsVariance +
            totalAgoVariance +
            totalDpkVariance +
            totalLpgVariance;

          this.totalAmount = this.convertThousand(
            totalPmsAmount + totalAgoAmount + totalDpkAmount + totalLpgAmount
          );
          this.totalManualAmount = this.convertThousand(
            totalManualPmsAmount +
              totalManualAgoAmount +
              totalManualDpkAmount +
              totalManualLpgAmount
          );

          this.totalVol = totalPmsVol + totalAgoVol + totalDpkVol + totalLpgVol;
          this.totalManualVol =
            totalManualPmsVol +
            totalManualAgoVol +
            totalManualDpkVol +
            totalManualLpgVol;

          this.pmsCheck = totalManualPmsVol;
          this.agoCheck = totalManualAgoVol;
          this.dpkCheck = totalManualDpkVol;
          this.lpgCheck = totalManualLpgVol;
          this.totalCheck =
            totalManualPmsVol +
            totalManualAgoVol +
            totalManualDpkVol +
            totalManualLpgVol;

          response.data.forEach((element) => {
            element.index = ++index;
            element.pumpVariance =
              element.pumpVariance == null || element.pumpVariance == 0
                ? 0
                : element.pumpVariance;
            element.manualVolumeSold =
              element.mannualVolumeSold != null ? element.mannualVolumeSold : 0;
            element.manualAmountSold =
              element.mannualAmountSold != null ? element.mannualAmountSold : 0;
            element.manualOpeningReading =
              element.mannualOpeningReading != null
                ? element.mannualOpeningReading
                : 0;
            element.manualLastReading =
              element.mannualLastReading != null
                ? element.mannualLastReading
                : 0;
            element.viewTransactionsButton = this.$t(
              "text.bVarianceReport.viewTransactions"
            );
          });
          let prods = response.data.reduce((acc, curr) => {
            if (acc.indexOf(curr.productName) < 0) {
              acc.push(curr.productName);
            }
            return acc;
          }, []);

          this.totalManualPmsVol = response.data
            .filter((el) => el.productName.toLowerCase() === "pms")
            .reduce((acc, cur) => (acc += cur.manualVolumeSold), 0);

          this.totalManualAgoVol = response.data
            .filter((el) => el.productName.toLowerCase() === "ago")
            .reduce((acc, cur) => (acc += cur.manualVolumeSold), 0);

          this.totalManualDpkVol = response.data
            .filter((el) => el.productName.toLowerCase() === "dpk")
            .reduce((acc, cur) => (acc += cur.manualVolumeSold), 0);

          this.totalManualLpgVol = response.data
            .filter((el) => el.productName.toLowerCase() === "lpg")
            .reduce((acc, cur) => (acc += cur.manualVolumeSold), 0);

          response.data.forEach((el) => {
            el.mode = "pump";
          });
          this.products = prods.sort();
          this.transKeep = response.data;
          this.salesTransactions = response.data;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.salesTransationsCount = response.data.length;
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
<style>
.table-container {
  width: 90%;
  margin: auto;
  text-align: center;
  background: white !important;
}
.table {
  font-size: 13px;
}

.inner-table-container {
  padding: 0 30px;
}
@page {
  margin: 0;
}
@media screen and (max-width: 768px) {
  .card_container.ml-3 {
    margin-top: 15px;
  }

  .fuel_consumption_button.installed__tanks_dropdown__row {
    height: 113px !important;
    text-align: center;
  }

  .field-input[data-v-74507c40] {
    position: relative;
    width: 100%;
    height: 56px;
  }

  .fuel_consumption_row_right_section_nw {
    height: 214px;
  }

  .fuel_consumption_row .fuel_consumption_row_right_section_nw {
    margin-top: 16px;
  }

  .transaction_period_text.text-center.branch__sales__text {
    margin-top: -11px;
  }

  .drop_down_input_group.sales_transaction_dropdown {
    margin-top: -97px;
    margin-left: 26px;
  }
}
</style>
